export const fr = {
    availability: {
        comingSoon: "Diaporama bientôt disponible...",
        unavailable: "Diaporama indisponible.",
        unavailableMessage: "Ce diaporama n'est plus visible publiquement."
    },
    controls: {
        toggleMediaDescription: "Afficher ou masquer la description du contenu multimédia"
    },
    notFound: {
        message: "Les URL de diaporama utilisent le format {{homeRoute}}/[:id utilisateur]/[:jeton]",
        title: "Diaporama introuvable"
    }
};
